export default "__VITE_ASSET__BUME1o7L__"